export const CLEAR_OPERATION_MANAGEMENT_STATE = 'CLEAR_OPERATION_MANAGEMENT_STATE';

export const GET_ALL_OPERATIONS = 'GET_ALL_OPERATIONS';
export const GET_ALL_OPERATIONS_SUCCESS = 'GET_ALL_OPERATIONS_SUCCESS';
export const GET_ALL_OPERATIONS_ERROR = 'GET_ALL_OPERATIONS_ERROR';

export const GET_OPERATION_BY_ID = 'GET_OPERATION_BY_ID';
export const GET_OPERATION_BY_ID_SUCCESS = 'GET_OPERATION_BY_ID_SUCCESS';
export const GET_OPERATION_BY_ID_ERROR = 'GET_OPERATION_BY_ID_ERROR';

export const CREATE_OPERATION = 'CREATE_OPERATION';
export const CREATE_OPERATION_SUCCESS = 'CREATE_OPERATION_SUCCESS';
export const CREATE_OPERATION_ERROR = 'CREATE_OPERATION_ERROR';

export const UPDATE_OPERATION = 'UPDATE_OPERATION';
export const UPDATE_OPERATION_SUCCESS = 'UPDATE_OPERATION_SUCCESS';
export const UPDATE_OPERATION_ERROR = 'UPDATE_OPERATION_ERROR';

export const DELETE_OPERATION = 'DELETE_OPERATION';
export const DELETE_OPERATION_SUCCESS = 'DELETE_OPERATION_SUCCESS';
export const DELETE_OPERATION_ERROR = 'DELETE_OPERATION_ERROR';
